import { render } from "./AppPopupSettings.vue?vue&type=template&id=f5ecf1b4"
import script from "./AppPopupSettings.vue?vue&type=script&lang=js"
export * from "./AppPopupSettings.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__